import { environment } from '../../environments/environment';

export function isProduction() {
  return !!environment.production;
}

export function isStaging() {
  return !isProduction() && environment.nodeEnv === 'Staging';
}
